module.exports = __webpack_public_path__ + "img/info8.ec091031.svg";